import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appListItem]'
})
export class AppListItemDirective {

  constructor(
    public tpl: TemplateRef<any>
  ) { }

}
